import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";

export default {
    title: "MyTrumpf/Partial Templates/Permissions",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

const defaultStoryArgs = {
    label: "Permission element",
    tooltip: true,
};

const getTooltipTemplate = () => html`
    <ux-icon name="info"></ux-icon>
    <ux-tooltip tooltip-target="ux-icon[name='info']">
        This is the minimum value available
    </ux-tooltip>
`;

const checkboxTemplate = (args = defaultStoryArgs) => {
    return html`
        <div class="ux-u-d-inline-flex ux-u-flex-ai-center">
            <ux-checkbox
                label="${args.label}"
                style="--ux-checkbox-spacing: 10px;"
            ></ux-checkbox>
            ${args.tooltip
                ? html`<ux-icon name="info"></ux-icon>
                      <ux-tooltip tooltip-target="ux-icon[name='info']">
                          This is the minimum value available
                      </ux-tooltip>`
                : ""}
        </div>
    `;
};

export const CheckboxTemplate = checkboxTemplate.bind({});
CheckboxTemplate.args = defaultStoryArgs;

const checkmarkTemplate = (args = defaultStoryArgs) => {
    return html`
        <div class="ux-u-d-inline-flex ux-u-flex-ai-center">
            <ux-icon
                class="ux-u-mr-xxxs"
                name="checkmark"
                weight="bold"
                fill="primary"
                size-l="18"
            ></ux-icon>
            <span class="ux-u-mr-xxxs">${args.label}</span>
            ${args.tooltip ? getTooltipTemplate() : ""}
        </div>
    `;
};

export const CheckmarkTemplate = checkmarkTemplate.bind({});
CheckmarkTemplate.args = defaultStoryArgs;

const crossTemplate = (args = defaultStoryArgs) => {
    return html`
        <div class="ux-u-d-inline-flex ux-u-flex-ai-center">
            <span
                style="color: #a1a1a1;"
                class="ux-u-d-flex ux-u-flex-ai-center"
            >
                <ux-icon
                    class="ux-u-mr-xxxs"
                    name="cross"
                    weight="bold"
                    size-l="15"
                ></ux-icon>
            </span>
            <span class="ux-u-mr-xxxs ux-color-disabled"> ${args.label}</span>
            ${args.tooltip ? getTooltipTemplate() : ""}
        </div>
    `;
};

export const CrossTemplate = crossTemplate.bind({});
CrossTemplate.args = defaultStoryArgs;
